import { SERVER_URL } from "../api";
import { WEB_URL } from "../constants/utils.constants";

export function getKeyByValue(object, value) {
  return Object.keys(object).find((key) => object[key] === value);
}

export const delay = (n) => new Promise((r) => setTimeout(r, n * 1000));

export const getNonEmpty = (field) => {
  const defaultLanguage = "es";
  if (field == null) return "----";
  if (typeof field === "string") {
    const t = field.trim();
    return t || "----";
  }
  if (typeof field !== "object" || !Object.keys(field).length) return "----";
  if (field[defaultLanguage] && field[defaultLanguage] !== "")
    return field[defaultLanguage];
  for (const lang of Object.keys(field)) {
    if (field[lang] && field[lang] !== "") return field[lang];
  }
  return "----";
};

export const checkIsEmpty = (field) => {
  return Object.values(field).every((x) => x === null || x === "" || x === " ");
};
export const formatDateForInput = (dateString) => {
  const date = new Date(dateString);
  const y = date.getFullYear();
  const m = padTo2Digits(date.getMonth() + 1);
  const d = padTo2Digits(date.getDate());
  const h = padTo2Digits(date.getHours());
  const min = padTo2Digits(date.getMinutes());
  return `${y}-${m}-${d}T${h}:${min}`;
};

/** Formato `YYYY-MM-DD` para `<input type="date">` (no usar `formatDateForInput`, que incluye hora). */
export const formatDateOnlyForInput = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return "";
  const y = date.getFullYear();
  const m = padTo2Digits(date.getMonth() + 1);
  const d = padTo2Digits(date.getDate());
  return `${y}-${m}-${d}`;
};

export const getFileType = (fileName) => {
  if (!fileName) return "unknown";
  const ext = fileName.split(".").pop();
  switch (ext) {
    case "pdf":
      return "file";
    case "m4a":
      return "audio";
    case "mp3":
      return "audio";
    case "mpa":
      return "audio";
    case "wma":
      return "audio";
    case "aif":
      return "audio";
    case "cda":
      return "audio";
    case "mid":
      return "audio";
    case "midi":
      return "audio";
    case "ogg":
      return "audio";
    case "wav":
      return "audio";
    case "wpl":
      return "audio";
    case "jpg":
      return "image";
    case "jpeg":
      return "image";
    case "png":
      return "image";
    case "svg":
      return "image";
    case "gif":
      return "image";
    case "avi":
      return "video";
    case "m4v":
      return "video";
    case "mkw":
      return "video";
    case "mp4":
      return "video";
    case "wmv":
      return "video";
    case "mov":
      return "video";
    default:
      return "unknown";
  }
};

export const padTo2Digits = (num) => {
  return num.toString().padStart(2, "0");
};

export const formatDate = (date) => {
  return [
    date.getFullYear(),
    padTo2Digits(date.getMonth() + 1),
    padTo2Digits(date.getDate()),
  ].join("-");
};

export const formatTime = (date) => {
  return [padTo2Digits(date.getHours()), padTo2Digits(date.getMinutes())].join(
    ":",
  );
};

export const combineDateAndTime = (date, time) => {
  if (!date || !time) return null;
  const dateParts = date.split("-");
  const timeParts = time.split(":");
  return new Date(
    dateParts[0],
    dateParts[1] - 1,
    dateParts[2],
    timeParts[0],
    timeParts[1],
  );
};

const crearHtmlCanva = (imageUrl, link) => {
  return `<!DOCTYPE html>
<html>
	<head>
		<title></title>
		<style>
			* {
				margin: 0;
				padding: 0;
				box-sizing: border-box;
			}
			
			html, body {
				height: 100%;
				width: 100%;
				overflow: hidden;
			}
			
			.newsletter-container {
				position: relative;
				width: 100vw;
				height: 100vh;
				background-image: url('${imageUrl}');
				background-size: cover;
				background-position: center;
				background-repeat: no-repeat;
				display: block;
				text-decoration: none;
				cursor: pointer;
			}
			
			.newsletter-container:hover {
				opacity: 0.95;
				transition: opacity 0.2s ease;
			}
		</style>
	</head>
	<body aria-disabled="false">
		<a href="${link}" class="newsletter-container" target="_blank" rel="noopener noreferrer">
		</a>
	</body>
</html>`;
};
export function createTemplateHtmlCanva(canva, link) {
  console.log(canva);
  const htmlCanva = crearHtmlCanva(canva, link);
  let templateHtml = htmlCanva;

  return templateHtml;
}

export function getFriendlyURL(text) {
  const a = "àáäâèéëêìíïîòóöôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;";
  const b = "aaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------";
  const p = new RegExp(a.split("").join("|"), "g");
  if (!text) return "";
  return String(text)
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(p, (c) => b.charAt(a.indexOf(c)))
    .replace(/&/g, "-y-")
    .replace(/[^\w\-]+/g, "")
    .replace(/\-\-+/g, "-")
    .replace(/^-+/, "")
    .replace(/-+$/, "");
}

function getTextForLangPreview(field, lang) {
  if (!field || typeof field !== "object") return "";
  if (lang && field[lang] && field[lang] !== "") return field[lang];
  return getNonEmpty(field);
}

function replacePlaceholderPreview(html, placeholder, value) {
  const safe = value != null ? String(value) : "";
  let out = html;
  [placeholder, placeholder.replace(/\s+/g, "")].forEach((p) => {
    out = out.split(p).join(safe);
  });
  return out;
}

function getTitleOrContentPreview(obj, lang) {
  if (!obj) return "";
  if (typeof obj === "string") return obj;
  if (typeof obj === "object" && obj !== null) {
    if (obj[lang] && String(obj[lang]).trim() !== "") return obj[lang];
    if (obj.es && String(obj.es).trim() !== "") return obj.es;
    if (obj.ca && String(obj.ca).trim() !== "") return obj.ca;
    if (obj.en && String(obj.en).trim() !== "") return obj.en;
    const first = Object.values(obj).find((v) => v && String(v).trim() !== "");
    return first != null ? first : "";
  }
  return "";
}

function replacePlaceholderRegexPreview(html, regex, value) {
  const safe = value != null ? String(value) : "";
  return html.replace(regex, safe);
}

function toPreviewImageUrl(imageUrlPartialOrFull) {
  if (!imageUrlPartialOrFull) return "";
  const v = String(imageUrlPartialOrFull);
  // En preview podemos recibir URLs completas (blob:, data:, http(s)) o ruta parcial (uploads/...)
  if (
    v.startsWith("blob:") ||
    v.startsWith("data:") ||
    v.startsWith("http://") ||
    v.startsWith("https://")
  ) {
    return v;
  }
  return `${SERVER_URL}/${v}`;
}

export function createTemplateHtml(
  title,
  description,
  templateHtml,
  imageUrlPartialOrFull,
) {
  const langCode = "es";
  // Valores del modelo newsletter: title y description (por idioma)
  const titleVal = getTitleOrContentPreview(title, langCode);
  const contentVal = getTitleOrContentPreview(description, langCode);
  const imageVal = toPreviewImageUrl(imageUrlPartialOrFull);

  const titleRegex = /\{\{\s*contact\.TITULO\s*\}\}/gi;
  const contentRegex = /\{\{\s*contact\.CONTENT\s*\}\}/gi;
  const imageRegex = /\{\{\s*contact\.IMAGEN\s*\}\}/gi;
  const paramsTitleRegex = /\{\{\s*params\.title\s*\}\}/gi;
  const paramsContentRegex = /\{\{\s*params\.content\s*\}\}/gi;

  let html = templateHtml;
  html = replacePlaceholderRegexPreview(html, titleRegex, titleVal);
  html = replacePlaceholderRegexPreview(html, contentRegex, contentVal);
  html = replacePlaceholderRegexPreview(html, imageRegex, imageVal);
  html = replacePlaceholderRegexPreview(html, paramsTitleRegex, titleVal);
  html = replacePlaceholderRegexPreview(html, paramsContentRegex, contentVal);
  html = replacePlaceholderPreview(html, "{{ params.title }}", titleVal);
  html = replacePlaceholderPreview(html, "{{ params.content }}", contentVal);
  html = replacePlaceholderPreview(html, "{{ contact.TITULO }}", titleVal);
  html = replacePlaceholderPreview(html, "{{ contact.CONTENT }}", contentVal);
  html = replacePlaceholderPreview(html, "{{ contact.IMAGEN }}", imageVal);
  html = replacePlaceholderPreview(html, "{{contact.TITULO}}", titleVal);
  html = replacePlaceholderPreview(html, "{{contact.CONTENT}}", contentVal);
  html = replacePlaceholderPreview(html, "{{contact.IMAGEN}}", imageVal);

  return html;
}

/**
 * Preview con título, descripción y datos del curso (INFO, PRECIO, URL_CURSO, NOMBRE_CURSO).
 * lang: idioma para el preview (ej. "es").
 */
export function createTemplateHtmlForPreview(
  title,
  description,
  templateHtml,
  lang,
  curso,
  imageUrlPartialOrFull,
) {
  const langCode = lang || "es";
  const titleVal = getTitleOrContentPreview(title, langCode);
  const contentVal = getTitleOrContentPreview(description, langCode);
  const imageVal = toPreviewImageUrl(imageUrlPartialOrFull);

  const titleRegex = /\{\{\s*contact\.TITULO\s*\}\}/gi;
  const contentRegex = /\{\{\s*contact\.CONTENT\s*\}\}/gi;
  const imageRegex = /\{\{\s*contact\.IMAGEN\s*\}\}/gi;
  const paramsTitleRegex = /\{\{\s*params\.title\s*\}\}/gi;
  const paramsContentRegex = /\{\{\s*params\.content\s*\}\}/gi;

  let html = templateHtml;
  html = replacePlaceholderRegexPreview(html, titleRegex, titleVal);
  html = replacePlaceholderRegexPreview(html, contentRegex, contentVal);
  html = replacePlaceholderRegexPreview(html, imageRegex, imageVal);
  html = replacePlaceholderRegexPreview(html, paramsTitleRegex, titleVal);
  html = replacePlaceholderRegexPreview(html, paramsContentRegex, contentVal);
  html = replacePlaceholderPreview(html, "{{params.title}}", titleVal);
  html = replacePlaceholderPreview(html, "{{ params.title }}", titleVal);
  html = replacePlaceholderPreview(html, "{{params.content}}", contentVal);
  html = replacePlaceholderPreview(html, "{{ params.content }}", contentVal);
  html = replacePlaceholderPreview(html, "{{ contact.TITULO }}", titleVal);
  html = replacePlaceholderPreview(html, "{{ contact.CONTENT }}", contentVal);
  html = replacePlaceholderPreview(html, "{{ contact.IMAGEN }}", imageVal);

  if (curso) {
    const slug =
      getTextForLangPreview(curso.enlace, langCode) ||
      (curso.titulo &&
        getFriendlyURL(getTextForLangPreview(curso.titulo, langCode)));
    const urlCurso = `${WEB_URL}/formacion/${slug || curso._id}`;
    const nombreCurso = getTextForLangPreview(curso.titulo, langCode);

    const imageUrl = curso.imageGridURL
      ? `${SERVER_URL}/${curso.imageGridURL}`
      : null;
    const modalidad = (curso.modalidad || "ONLINE").toUpperCase();
    const fechaCurso = (() => {
      if (!curso.fechaIni) return "";
      const d = new Date(curso.fechaIni);
      if (Number.isNaN(d.getTime())) return "";
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = String(d.getFullYear()).slice(-2);
      return `${day}/${month}/${year}`;
    })();
    const duracion = curso.duracion || "";
    const creditosDefinidos = curso.creditosDefinidos !== false;
    const estadoCert =
      creditosDefinidos && curso.creditos != null
        ? `${curso.creditos} CFC`
        : { es: "En Trámite", ca: "En Tràmit", en: "In Process" }[langCode] ||
          "En Trámite";

    const iconColor = "#2563eb";
    const textStyle =
      "font-family: Arial, sans-serif; font-size: 14px; color: #333; margin: 0; padding: 4px 0;";
    const iconStyle = `color: ${iconColor}; font-size: 14px; vertical-align: middle;`;
    const infoRows = [
      `<tr><td style="${textStyle}">${modalidad}</td></tr>`,
      `<tr><td style="${textStyle}"><span style="${iconStyle}">📅</span> ${fechaCurso}</td></tr>`,
      `<tr><td style="${textStyle}"><span style="${iconStyle}">🕐</span> ${duracion}</td></tr>`,
      `<tr><td style="${textStyle}"><span style="${iconStyle}">🎓</span> ${estadoCert}</td></tr>`,
    ].join("");
    const contentCell = `
    <td style="width: 50%; padding: 24px; font-family: Arial, sans-serif; color: #333; vertical-align: top;">
      <table cellspacing="0" cellpadding="0" style="width: 100%;">
        ${infoRows}
      </table>
    </td>`;
    const imageCell = imageUrl
      ? `<td style="width: 50%; padding: 0; text-align: center; vertical-align: top;">
      <img src="${imageUrl}" alt="Curso" style="max-width: 100%; height: auto; display: block;" />
    </td>`
      : "";
    const infoHtml = `<table cellspacing="0" cellpadding="0" style="width: 100%; max-width: 600px; margin: 16px 0;">
    <tr>${imageUrl ? [imageCell, contentCell].join("") : contentCell}</tr>
  </table>`;

    const pricing = (curso.pricing || []).filter((p) => p.active !== false);
    const rows = pricing
      .map((p) => {
        const valor = p.value != null ? `${Number(p.value)} €` : "";
        const info = p.info || "";
        return `<tr>
        <td style="padding: 10px 12px; border: 1px solid #ddd;">${valor}</td>
        <td style="padding: 10px 12px; border: 1px solid #ddd;">${info}</td>
      </tr>`;
      })
      .join("");
    const precioHtml =
      rows.length > 0
        ? `<table style="width: 100%; max-width: 500px; border-collapse: collapse; margin: 16px 0; font-size: 14px;">
    <thead>
      <tr style="background: #f5f5f5;">
        <th style="padding: 10px 12px; border: 1px solid #ddd; text-align: left;">Preu</th>
        <th style="padding: 10px 12px; border: 1px solid #ddd; text-align: left;">Usuari</th>
      </tr>
    </thead>
    <tbody>${rows}</tbody>
  </table>`
        : "";

    html = replacePlaceholderPreview(html, "{{ contact.URL_CURSO }}", urlCurso);
    html = replacePlaceholderPreview(html, "{{ contact.INFO }}", infoHtml);
    html = replacePlaceholderPreview(html, "{{ contact.PRECIO }}", precioHtml);
    html = replacePlaceholderPreview(
      html,
      "{{ contact.NOMBRE_CURSO }}",
      nombreCurso,
    );
  }

  return html;
}

export const cleanHtmlAndTruncate = (
  htmlString,
  maxLength = 100,
  suffix = "...",
) => {
  if (!htmlString || typeof htmlString !== "string") {
    return "";
  }

  // Eliminar todas las etiquetas HTML
  const cleanText = htmlString
    .replace(/<[^>]*>/g, "") // Eliminar etiquetas HTML
    .replace(/&nbsp;/g, " ") // Reemplazar entidades HTML comunes
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/\s+/g, " ") // Normalizar espacios en blanco
    .trim(); // Eliminar espacios al inicio y final

  // Truncar si es necesario
  if (cleanText.length <= maxLength) {
    return cleanText;
  }

  // Encontrar el último espacio antes del límite para no cortar palabras
  const truncated = cleanText.substring(0, maxLength);
  const lastSpaceIndex = truncated.lastIndexOf(" ");

  if (lastSpaceIndex > maxLength * 0.8) {
    return truncated.substring(0, lastSpaceIndex) + suffix;
  }

  return truncated + suffix;
};
